import { cn } from '@data/utils/cn/cn';

interface LoadingBarProps {
  className?: string;
  /**
   * When true, the bar is exposed to assistive tech as a polite live region
   * that announces "Loading" on mount. Leave false (default) when rendering
   * many bars (e.g. inside a table) and let the parent announce instead.
   */
  announce?: boolean;
  loadingLabel?: string;
}

export function LoadingBar({
  className,
  announce = false,
  loadingLabel = 'Loading',
}: LoadingBarProps) {
  const a11yProps = announce
    ? {
        role: 'progressbar' as const,
        'aria-busy': true,
        'aria-label': loadingLabel,
      }
    : { 'aria-hidden': true };

  return (
    <div
      {...a11yProps}
      className={cn(
        'h-5 animate-pulse self-stretch rounded bg-neutral-100',
        className
      )}
    />
  );
}
